import { useEffect } from "react";

import { Link } from "common/components";
import { useDispatch } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { interpolate } from "domains/language/interpolate";
import { activateModal } from "domains/modal/actions";

type ErrorModalProps = { error?: boolean };

export const useErrorModal = ({ error }: ErrorModalProps) => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  const supportEmail = (supportEmail: string) => <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>;

  useEffect(() => {
    if (!error) return;
    dispatch(
      activateModal({
        id: "Error",
        params: { message: interpolate(translate("app.topic.follow.error_message"), { supportEmail }) },
      }),
    );
  }, [dispatch, error, translate]);
};
